import { render } from "./QuickPeriodComponent.vue?vue&type=template&id=08aad638&ts=true"
import script from "./QuickPeriodComponent.vue?vue&type=script&lang=ts"
export * from "./QuickPeriodComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src720582188/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__